const roomsKeys = {
  index: "rooms",
  roomList: "rooms-list",
  roomDetails: "room-details",
  roomUsedLicenses: "room-used-licenses",
  updateRoom: "update-room",
  updateRoomSettings: "update-room-settings",
  updateRoomCustomAlarms: "update-room-custom-alarms",
  getRoomsByOwnerId: "get-rooms-by-owner-id",
  getRoomsByOwnerIdWithLicense: "get-rooms-by-owner-id-with-license",
  getRoomsByUserId: "get-rooms-by-user-id",
  updateRoomByMonitorId: "update-room-by-monitor-id",
  createRoom: "create-room",
  devicesByRoom: "devices-by-room",
  swapDevice: "swap-device",
};

export const roomListKey = () => {
  return [roomsKeys.index, roomsKeys.roomList];
};

export const roomDetailsKey = (id: string) => {
  return [roomsKeys.index, roomsKeys.roomDetails, id];
};

export const roomUsedLicensesKey = (id: string) => {
  return [roomsKeys.index, roomsKeys.roomUsedLicenses, id];
};

export const updateRoomKey = (id: string) => {
  return [roomsKeys.index, roomsKeys.updateRoom, id];
};

export const updateRoomSettingsKey = (id: string) => {
  return [roomsKeys.index, roomsKeys.updateRoomSettings, id];
};

export const updateRoomCustomAlarmsKey = (id: string) => {
  return [roomsKeys.index, roomsKeys.updateRoomCustomAlarms, id];
};

export const getRoomsByOwnerIdKey = (ownerId: string) => {
  return [roomsKeys.index, roomsKeys.getRoomsByOwnerId, ownerId];
};

export const getRoomsByOwnerIdWithLicenseKey = (ownerId: string) => {
  return [roomsKeys.index, roomsKeys.getRoomsByOwnerIdWithLicense, ownerId];
};

export const getRoomsByUserIdKey = (userId: string) => {
  return [roomsKeys.index, roomsKeys.getRoomsByUserId, userId];
};

export const updateRoomByMonitorIdKey = (id: string) => {
  return [roomsKeys.index, roomsKeys.updateRoomByMonitorId, id];
};

export const createRoomKey = () => {
  return [roomsKeys.index, roomsKeys.createRoom];
};

export const devicesByRoomKey = (roomId: string) => {
  return [roomsKeys.index, roomsKeys.devicesByRoom, roomId];
};

export const swapDeviceKey = (roomId: string) => {
  return [roomsKeys.index, roomsKeys.swapDevice, roomId];
};
